module.exports = __webpack_public_path__ + "img/05.b4619909.jpg";